const modal = require('../support/Modal');

/*
 |--------------------------------------------------------------------------
 | Document Ready Function
 |--------------------------------------------------------------------------
 */
$(function () {
    'use strict';

    /**
     * Send links with the "data-method" attribute as forms.
     *
     * @link https://laravel.com/docs/routing#form-method-spoofing
     */
    $('a[data-method]').click(function (event) {
        let $this = $(this),
            token = $('meta[name="csrf-token"]').attr('content'),
            method = $this.data('method'),
            action = $this.attr('href');

        if (typeof method === 'undefined' || method === 'GET') return;

        event.preventDefault();

        $(`<form action="${action}" method="POST" style="display: none"></form>`)
            .append(`<input name="_token" value="${token}">`)
            .append(`<input name="_method" value="${method}">`)
            .appendTo('body')
            .submit();
    });

    /**
     * Set link as active for category navigation in articles.
     */
    $('.menu-categories-items')
        .mouseover(function () {
            $(this).prev().addClass('hover');
        })
        .mouseout(function () {
            $(this).prev().removeClass('hover');
        });

    /**
     * Available copy to clipboard.
     */
    let copyToClipboard = (textToCopy) => {
        return new Promise((res, rej) => {
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val(textToCopy).select();
            document.execCommand('copy') ? res() : rej();
            $temp.remove();
        });
    };

    $('.clipboard-copy').on('click', (e) => {
        e.preventDefault();

        copyToClipboard($(e.target).parent().children('.clipboard-content').text())
            .then((_) => {
                $('.clipboard-copy, .clipboard-copy-success').addClass('active');

                setTimeout(function () {
                    $('.clipboard-copy, .clipboard-copy-success').removeClass('active');
                }, 1500);
            })
            .catch((_) => {
                $('.clipboard-copy, .clipboard-copy-error').addClass('active');

                setTimeout(function () {
                    $('.clipboard-copy, .clipboard-copy-error').removeClass('active');
                }, 1500);
            });
    });

    /**
     * Custom clipboard content share.
     */
    if ($('.clipboard-content-share').length) {
        $('.clipboard-content-share').text($("meta[property='og:url']").prop('content'));
    }

    /*
     * Available click to top all site.
     */
    $(document).on('click', '.top-link', (e) => {
        e.preventDefault();

        $('html, body').animate({ scrollTop: 0 }, 1000);
    });

    /**
     * Set custom event share button.
     */
    $(document).on('click', '.navigation-share', (e) => {
        e.preventDefault();

        let shareData = {
            title: $("meta[property='og:title']").prop('content'),
            text: $("meta[property='og:description']").prop('content'),
            url: $("meta[property='og:url']").prop('content'),
        };

        if (navigator.canShare && navigator.canShare(shareData)) {
            navigator.share(shareData);

            return;
        }

        modal.trigger($('#shareModal'));
    });

    /*
     * Available click to region inside.
     */
    $('.link-to-region').on('click', (e) => {
        e.preventDefault();

        let hash = e.currentTarget.hash,
            top = $(document).width() > 767 ? 200 : 150;
        hash = hash.split('#')[1];

        $('.link-to-region').each((i, e) => {
            $(e).removeClass('active');
        });

        $(e.currentTarget).addClass('active');

        $('html, body').animate({ scrollTop: $('.' + hash).offset().top - top }, 1000);
    });
});
